import React from 'react'

import PropTypes from 'prop-types'

import FullTextPreview from 'components/FilePreview/FullTextPreview'
import ImagePreview from 'components/FilePreview/ImagePreview'
import VideoPreview from 'components/FilePreview/VideoPreview'

import Styles from './index.scss'


const PitchReference = (props) => {
  let previews = props.reference.map((source) => {
    if (source.filetype === 'image') {
      previews = (
        <a
          className={Styles.imgFile}
          href={source.urlRawFile}
          target="_blank"
          rel="noopener noreferrer"
          key={source.id}
        >
          <ImagePreview
            key={source.id}
            reference={source}
            className="img-responsive"
          />
        </a>
      )
    }
    if (source.filetype === 'video') {
      previews = (
        <div>
          <div className="pull-left">
            <VideoPreview
              key={source.id}
              portfolio={{
                url: source.url,
                urlRawFile: source.urlRawFile,
              }}
              fullPage="fullPage"
              style={{ maxWidth: '225px' }}
            />
          </div>
          <div className="pull-right">
            <a
              href={source.urlRawFile}
              className={`${Styles.fullpage} btn btn-default`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Fullpage
            </a>
          </div>
        </div>
      )
    }
    if (source.filetype === 'text') {
      previews = (
        <a
          className={Styles.textFile}
          href={source.urlRawFile}
          target="_blank"
          rel="noopener noreferrer"
          key={source.id}
        >
          <FullTextPreview
            key={source.id}
            portfolio={source}
            renderTextLayer
            documentClassName="pdf-pitch"
          />
        </a>
      )
    }
    return previews
  })


  return (
    <div className="table-scrollable table-scrollable-borderless">

      {props.reference.length > 0
        ? (
          <table className="table table-hover table-light">
            <thead>
              <tr>
                <th>Pitch Reference</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: '100%', display: 'inline-flex' }} >
                  {previews}
                </td>
              </tr>
            </tbody>
          </table>
          )
        : ''
      }
    </div>
  )
}

PitchReference.propTypes = {
  reference: PropTypes.arrayOf(PropTypes.object).isRequired,
}


export default PitchReference
